export default "__VITE_ASSET__BYZzLdmG__"